"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";

const EXCLUDED_PATHS = new Set(["/faqs"]);

export default function EdmundsScript() {
  const pathname = usePathname();

  if (EXCLUDED_PATHS.has(pathname)) {
    return null;
  }

  return (
    <Script
      src="https://content-container.edmunds.com/1945075.js"
      strategy="afterInteractive"
    />
  );
}
